import { render, staticRenderFns } from "./AddKeywordModal.vue?vue&type=template&id=3645b617"
import script from "./AddKeywordModal.vue?vue&type=script&lang=js"
export * from "./AddKeywordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports